import { Height } from '@mui/icons-material';

const SellStyle = {
    container: {},
    imageHeaderText: {
        color: 'text.secondary',
        fontSize: 16,
        fontWeight: '400',
        mb: 0.5
    },
    imageHeader: {
        display: 'flex'
    },
    cameraContainer: {
        width: '100%',
        // height: 164,
        display: 'flex',
        alignItems: 'center',
        bgcolor: '#F5F5F5',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        borderRadius: 4,
        position: 'relative',
        justifyItems: 'flex-start',
        mb: 2,
        flexWrap: 'wrap',

        p: 0.5
    },
    uploaderStyle: {
        width: 128,
        height: 128,
        backgroundColor: '#ffffff',
        borderRadius: 2,
        cursor: 'pointer',
        position: 'relative',
        m: 1
    },
    uploaderIcon: {
        fontSize: 60,
        color: '#9A9FA5',
        position: 'absolute',

        marginTop: '50%',
        marginLeft: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 0,

        cursor: 'pointer',
        '&:hover': {
            color: 'blue'
        }
    },
    uploaderInput: {
        width: 128,
        height: 128,
        opacity: 0,
        cursor: 'pointer',
        backgroundColor: 'transparent',

        zIndex: 9999
    },
    imageStyle: {
        width: 128,
        height: 128,
        // uploaded photos come in any shape: crop to the square instead of squashing
        objectFit: 'cover',
        display: 'block',
        borderRadius: 2,
        cursor: 'pointer',
        m: 0.25,
        position: 'relative',
        zIndex: 0,
        '&:hover': {
            zIndex: 1,
            '& $imageDeleteIcon': {
                display: 'block'
            },
            '& $imageDeleteIcon:hover': {
                color: '#fff000'
            }
        }
    },
    takenImage: {
        width: 128,
        height: 128,
        borderRadius: 2,
        cursor: 'pointer',

        position: 'relative',
        zIndex: 0,
        '&:hover': {
            zIndex: 1
        },

        '&:hover $imageDeleteIcon': {
            display: 'block',
            color: '#fff000',
            cursor: 'pointer'
        },
        m: 0.25
    },
    editIcon: {
        position: 'absolute',
        top: -5,
        right: -5,
        zIndex: 9999,
        visibility: 'visible',
        // color: '#ffffff',

        cursor: 'pointer'
    },
    // Preview column. The card used to be `position: fixed` with no width, so it sized itself to the uploaded
    // photo / an unbroken title and spilled over the form. It now stays visible while the form scrolls (sticky),
    // but within its own column and at a bounded width.
    displayCardContainer: { width: '100%', height: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', mb: 3, p: 2 },
    displayCard: {
        position: 'sticky',
        top: 88, // below the fixed top bar
        width: '100%',
        maxWidth: 300,
        minWidth: 0
    },
    chooseAddressText: {
        color: 'text.secondary',
        fontSize: 16,
        fontWeight: '400'
    },
    multiBoxesContainer: {
        width: '100%',
        display: 'flex',
        flexGrow: 1,
        flexDirection: { xs: 'column', sm: 'row' },
        flexWrap: 'nowrap',
        justifyContent: { xs: 'flex-start', sm: 'space-between' },
        gap: 1,
        alignItems: { xs: 'flex-end', sm: 'center' },
        my: 2
    }
};

export default SellStyle;
